import { PUBLIC_BRAZE_SDK_KEY, PUBLIC_BRAZE_SDK_URL } from '$env/static/public';
import { browser } from '$app/environment';
import { get } from 'svelte/store';
import { userStore } from '$lib/stores/userStore';
import { analytics } from './segment';

type Braze = typeof import('@braze/web-sdk');

let brazeInstance: Braze | null = null;

export const initBraze = async (): Promise<Braze | null> => {
  if (brazeInstance) {
    return brazeInstance;
  }

  if (!browser || !PUBLIC_BRAZE_SDK_KEY || !PUBLIC_BRAZE_SDK_URL) {
    return null;
  }

  try {
    const braze = await import('@braze/web-sdk');

    braze.initialize(PUBLIC_BRAZE_SDK_KEY, {
      baseUrl: PUBLIC_BRAZE_SDK_URL,
      enableLogging: process.env.NODE_ENV !== 'production',
      allowUserSuppliedJavascript: true,
      doNotLoadFontAwesome: true,
      minimumIntervalBetweenTriggerActionsInSeconds: 5,
    });

    braze.automaticallyShowInAppMessages();

    const user = get(userStore).user;

    const userId =
      user?.user_metadata?.user_canonical_id || analytics.instance?.user().anonymousId();

    if (userId) {
      braze.changeUser(userId);
    }

    braze.openSession();

    brazeInstance = braze;

    return brazeInstance;
  } catch (error) {
    return null;
  }
};
